import React, { useState } from 'react';
import './RateTable.css';
import RateModel from './RateModel'; // Import RateModel component
import apiService from '../api/apiService';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RateTable = ({ data, setData }) => {
  const [editingItem, setEditingItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Handle Edit Button Click (Opens Modal)
  const handleEditClick = item => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  // Handle Save from Modal
  const handleEdit = updatedItem => {
    setData(prevData =>
      prevData.map(item => (item.id === updatedItem.id ? updatedItem : item))
    );
    setIsModalOpen(false);
    setEditingItem(null);
  };

  const handleDelete = async id => {
    try {
      const response = await apiService.delete(`/rates/${id}/`);
      setData(prevData => prevData.filter(item => item.id !== id));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="rate-table-container">
      <table className="rate-table">
        <thead>
          <tr>
            <th>Room Type</th>
            <th>Deals</th>
            <th>Cancellation Policy</th>
            <th>Deal Price</th>
            <th>Rate</th>
            <th>Availability</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map(item => (
              <tr key={item.id}>
                <td>{item.room_type}</td>
                <td>{item.deals}</td>
                <td>{item.cancellation_policy}</td>
                <td>{item.deal_price}</td>
                <td>{item.rate}</td>
                <td>{item.availability ? 'Available' : 'Unavailable'}</td>
                <td>
                  <div className="options-menu">
                    <button className="options-button">⋮</button>
                    <div className="dropdown-menu">
                      <button onClick={() => handleEditClick(item)}>
                        Edit
                      </button>
                      <button onClick={() => handleDelete(item.id)}>
                        Delete
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7">No data available</td>
            </tr>
          )}
        </tbody>
      </table>

      <>
        {isModalOpen && (
          <RateModel
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSave={handleEdit}
            existingData={editingItem}
          />
        )}
        <ToastContainer />
      </>
    </div>
  );
};

export default RateTable;
